import Page from "./Page";
import PageHeader from "./PageHeader";
import PageBody from "./PageBody";
import PageLoading from "./PageLoading";

const exportable = { Page, PageHeader, PageBody, PageLoading };

export default exportable;
